const getRelationship = (relationship,gender) => {
    if (relationship === 'Mother') {
        return gender === 'male' ? 'Son' : 'Daughter';
      } else if (relationship === 'Father') {
        return gender === 'male' ? 'Son' : 'Daughter';
      } else if (relationship === 'Spouse') {
        return gender === 'male' ? 'Husband' : 'Wife';
      } else if (relationship === 'Child') {
        return gender === 'male' ? 'Father' : 'Mother';
      } else if (relationship === 'Sibling') {
        return gender === 'male' ? 'Brother' : 'Sister';
      } else if (relationship === 'Grandfather') {
        return gender === 'male' ? 'Grandson' : 'Granddaughter';
      } else if (relationship === 'Grandmother') {
        return gender === 'male' ? 'Grandson' : 'Granddaughter';
      } else if (relationship === 'Grandchild') {
        return gender === 'male' ? 'Grandfather' : 'Grandmother';
      } else if (relationship === 'Aunt/Uncle') {
        return gender === 'male' ? 'Nephew' : 'Niece';
      } else if (relationship === 'Niece/Nephew') {
        return gender === 'male' ? 'Uncle' : 'Aunt';
      } else if (relationship === 'Cousin') {
        return 'Cousin'; // Same for both genders
      } else if (relationship === 'Guardian') {
        return 'Ward'; // Same for both genders
      } else if (relationship === 'Foster Parent') {
        return gender === 'male' ? 'Foster Son' : 'Foster Daughter';
      } else if (relationship === 'Foster Child') {
        return gender === 'male' ? 'Foster Father' : 'Foster Mother';
      } else if (relationship === 'Step Parent') {
        return gender === 'male' ? 'Step Son' : 'Step Daughter';
      } else if (relationship === 'Step Child') {
        return gender === 'male' ? 'Step Father' : 'Step Mother';
      } else if (relationship === 'Adoptive Parent') {
        return gender === 'male' ? 'Adopted Son' : 'Adopted Daughter';
      } else if (relationship === 'Adopted Child') {
        return gender === 'male' ? 'Adoptive Father' : 'Adoptive Mother';
      } else if (relationship === 'Neighbor') {
        return 'Neighbor'; // Same for both genders
      } else {
        return 'Unknown';
      }
}
 
export default getRelationship;